import { UseAxiosResult } from "axios-hooks";
import formatUrl from "utils/formatUrl";

import api from "config/urls/api";

import { UseSelectUserManagementApi } from "./setup";

export const useCreateClientSelectLog = (): UseAxiosResult => {
  return UseSelectUserManagementApi(
    {
      url: formatUrl(api.log.clientSelect),
      method: "POST",
    },
    {
      manual: true,
    }
  );
};
